import axios from "axios";
import { useAuthStore } from "@/stores/auth.store";
import router from "@/router";

export default function axiosSetup() {
    axios.defaults.baseURL = "/api/v1";
    axios.defaults.headers.common = {
        Accept: "application/json",
        "Content-Type": "application/json",
    };

    axios.interceptors.request.use(
        async (config) => {
            const authStore = useAuthStore();
            const token = authStore.user?.token;
            // if (config.url !== "auth/refresh-token") {
            //     token = await AuthService.GetAccessToken();
            // }
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            return config;
        },
        function (error) {
            // Do something with request error
            return Promise.reject(error);
        }
    );

    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const authStore = useAuthStore(); // Pobieramy store
            // if(error.response && error.response.status === 423 ){
            //     await AuthService.Unauthorized();
            //     await licenceService.licenseError(error.response.data.status)
            //     console.error("Licence issue");
            //     throw new axios.Cancel(error.response).message.data;
            // }

            if (error.response && error.response.status === 403) {
                await router.push({ name: "Forbidden" })
                return Promise.reject(error);
            }

            if (error.response && error.response.status === 401) {
                authStore.logout();
                return Promise.reject(error);
            }

            // if (error.response && error.response.status == 422) {
            //     throw new axios.Cancel(error.response).message.data;
            // }

            return Promise.reject(error.response);
        }
    );
}

